import { render, staticRenderFns } from "./editApplyRoomDiscount.vue?vue&type=template&id=006c3682&scoped=true"
import script from "./editApplyRoomDiscount.vue?vue&type=script&lang=js"
export * from "./editApplyRoomDiscount.vue?vue&type=script&lang=js"
import style0 from "./editApplyRoomDiscount.vue?vue&type=style&index=0&id=006c3682&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006c3682",
  null
  
)

export default component.exports